<template>
  <div>
    <div id="info-square" class="p-3 mt-3">
      <h6>{{ t("YOUAREINCONTROL") }}</h6>
      <p>{{ t("PAYMENTEXPLAINER") }}</p>
    </div>
    <div id="options" class="mt-5">
      <div class="option-square-a p-3">
        <div class="left-panel">
          <h3>{{ currencyFormat(minimumPaymentAmount) }}</h3>
          <p class="m-0">{{ t("MINIMUMPAYMENT") }}</p>
        </div>
        <div class="right-panel">
          <button class="select-payment-btn" @click="selectAmount('minimum')">
            {{ t("SELECT") }}
          </button>
        </div>
      </div>
      <div class="option-square-a mt-5">
        <div class="left-panel p-3">
          <h3>{{ t("CUSTOMIZE") }}</h3>
          <p class="m-0">{{ t("CUSTOMPAYMENT") }}</p>
        </div>
        <div class="right-panel p-3">
          <button class="select-payment-btn" @click="selectAmount('custom')">
            {{ t("SELECT") }}
          </button>
        </div>
        <div class="bottom-panel">{{ t("CUSTOMPAYMENTEXPLAINER") }}</div>
      </div>
      <div class="option-square-a mt-5">
        <div class="left-panel p-3">
          <h3>{{ currencyFormat(payableToday) }}</h3>
          <p class="m-0">{{ t("PAYOFFEXPLAINER") }}</p>
        </div>
        <div class="right-panel p-3">
          <button class="select-payment-btn" @click="selectAmount('payoff')">
            {{ t("SELECT") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { inject } from "vue";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import currencyFormat from "@/apps/credit-line/helpers/currencyFormatter.helper";

const { t } = useI18n();
const minimumPaymentAmount = inject("minimumPaymentAmount");
const payableToday = inject("payableToday");
const selectAmount = inject("selectAmount");
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";

#info-square {
  border-radius: 5px;
  -webkit-box-shadow: 2px 3px 12px 1px rgba(0, 0, 0, 0.55);
  box-shadow: 2px 3px 12px 1px rgba(0, 0, 0, 0.55);
}

.select-payment-btn {
  border: none;
  height: 40px;
  background-color: $pj-color-green;
  color: $pj-color-white;
  border-radius: 10px;
  font-weight: bold;
  font-size: 100%;
}

.option-square-a {
  border-width: thin;
  border-color: black;
  border-style: solid;
  border-radius: 15px;
  display: flex;
  justify-content: space-between;
  flex-flow: row wrap;
}

.right-panel {
  align-items: center;
  display: flex;
  width: 50%;
  justify-content: flex-end;
}

.left-panel {
  width: 50%;
}

.bottom-panel {
  width: 100%;
  background-color: $pj-color-green-hover;
  border-bottom-right-radius: 15px;
  border-bottom-left-radius: 15px;
  height: 40px;
  align-items: center;
  display: flex;
  padding-left: 5%;
}
</style>
